import styled from 'styled-components';

import Feature1 from '../../../common/Images/Home/feature1.png';
import Feature2 from '../../../common/Images/Home/feature2.png';
import Feature3 from '../../../common/Images/Home/feature3.png';


const Img = styled.img`
    box-shadow: 0px -6px 20px 0px rgba(31, 30, 44, 0.1);
    border-radius: 1.5rem;
    width: 100%;
    max-width: 500px;
    height: auto;
    object-fit: contain;
`;

const ImgNoShadow = styled.img`
    border-radius: 1.5rem;
    width: 100%;
    max-width: 618px;
    height: auto;
    object-fit: contain;
    object-position: center;
    display: block;
    
    @media (max-width: 768px) {
        max-width: 464px;
    }
`;
const FeaturesSection = () => {
    const features = [
        {
            image: Feature1,
            title: 'Professional profile built for transparency',
            description:
                '75% of patients research treatment prices before they choose a provider. Be:Seen allows physicians to easily share their prices for patients to consider.',
        },
        {
            image: Feature2,
            title: 'Swift payment for services you provide.',
            description:
                'Patients simply book their appointment,  we collect the payment and make sure you get paid for the services provided free of chargebacks, collections, or payment delays.',
        },
        {
            image: Feature3,
            title: 'Focus on patients not paperwork.',
            description:
                '75% of patients research treatment prices before they choose a provider. Be:Seen allows physicians to easily share their prices for patients to consider.',
        },
    ];
    return (
            <div className="flex flex-col justify-between items-center gap-8 md:gap-20 lg:gap-5 w-full bg-[#FAFAFA] overflow-x-hidden py-[80px] px-8 md:p-16 md:pb-[140px]">
            {features.map((item, index) => {
                return (
                    <div key={index} className="w-full flex justify-center">
                        <div
                            className={`w-full max-w-[1300px] flex flex-col ${index === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'}
                                        justify-between items-center gap-4 md:gap-8 xl:gap-16`}>

                            <div className='lg:w-[50%] xl:w-[50%] flex justify-center items-center overflow-visible pb-5 lg:pb-0'>
                                <ImgNoShadow src={item.image} alt={item.title} className='hidden sm:block' />
                            </div>

                            <div className={`flex flex-col break-words gap-5 sm:gap-4 text-center lg:text-left w-full lg:w-[50%] max-w-[545px]`}>
                                <p className="text-[#3E3E4A] text-[48px] font-bold leading-tight">{item.title}</p>
                                <p className="text-[#555]  font-normal text-[20px] leading-normal">{item.description}</p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default FeaturesSection;
